import html from "./ExternalApplicationModal.html"
import "./ExternalApplicationModal.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('externalApplicationModal', {
	template: html,
	bindings: {
		modalView: '<',
		hide: '<',
		patientId: '<',
		tabKey: '<',
		whitelistedUrls: '<',
		onNewExternalAppOpen: '&',
		onDismiss: '&',
		onBack: '&',
		colorScheme: '<',
		disableDefaultInteractions: '<'
	},
	controller: 'externalApplicationModalController',
	controllerAs: 'vm'
});

module.controller("externalApplicationModalController", ["$scope",
	function ($scope) {

		var vm = this;

		function getTopModal(stack) {
			if (!stack.modalView) {
				return stack;
			}
			return getTopModal(stack.modalView);
		}

		vm.getCurrentApplicationUrl = function () {
			if (!vm.modalView) return undefined;

			if (!vm.modalView.modalView) return undefined;

			var topModal = getTopModal(vm.modalView);
			return topModal.applications[topModal.applications.length - 1].url;
		};

		vm.openNewExternalApp = function (event) {
			vm.onNewExternalAppOpen({ event: event });
		};

		vm.dismissApp = function (event) {
			vm.onDismiss({ event: event });
		};

		vm.goBack = function (event) {
			vm.onBack({ event: event });
		};
	}
]);